import Logo from "./App.vue";
import VueGoogleCharts from 'vue-google-charts'
import ZenHub from 'C:/inetpub/wwwroot/ZenWeb/ZenApp/ComponentLib/plugins/zen-hub'
import Globals from 'C:/inetpub/wwwroot/ZenWeb/ZenApp/ComponentLib/plugins/globals'


Vue.use(VueGoogleCharts)
Vue.use(ZenHub)
Vue.use(Globals)

export default {
  Logo
};
